import { Button, Select } from 'antd';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFilter, getProduct } from '../../api/index.js';
import LightSvg from '../../assets/icon/icon_light.svg';
import LinkSvg from '../../assets/icon/icon_link.svg';
import titlePng from '../../assets/images/big-title.png';
import WeightJson from '../../assets/json/category-weight.json';
import containerStyle from '../../components/container/index.module.scss';
import VideoBg from '../../components/video-bg/bg.jsx';
import style from './home.module.scss';

function buildOptions(options) {
  return options.map((item) => ({
    label: item,
    value: item,
  }));
}

function checkWeight(category, brand) {
  if (!WeightJson[brand]) return false;

  for (const market in WeightJson[brand]) {
    if (WeightJson[brand][market][category]) return true;
  }

  return false;
}

function HomePage() {
  const navigate = useNavigate();

  const [marketOptions, setMarketOptions] = useState([]);
  const [marketData, setMarketData] = useState(null);

  const [verticalOptions, setVerticalOptions] = useState([]);
  const [verticalData, setVerticalData] = useState(null);

  const [verticalOptions2, setVerticalOptions2] = useState([]);
  const [verticalData2, setVerticalData2] = useState(null);

  const [brandOptions, setBrandOptions] = useState([]);
  const [brandData, setBrandData] = useState(null);

  const getMarketOptions = useCallback(async () => {
    const { data } = await getFilter('market');
    setMarketOptions(buildOptions(data));
  }, [setMarketOptions]);
  useEffect(() => {
    getMarketOptions().catch((err) => {
      console.error('get market options error', err);
    });
  }, [getMarketOptions]);

  const getVerticalOptions = useCallback(async () => {
    const { data } = await getFilter('vertical', {
      market: marketData ? [marketData] : [],
    });
    if (marketData === 'US') {
      setVerticalOptions(
        buildOptions(
          data.filter(
            (e) => e !== 'Lifestyle Nutrition' && e !== 'Other Nutrition'
          )
        )
      );
    } else if (marketData === 'UK') {
      setVerticalOptions(
        buildOptions(
          data.filter(
            (e) => e !== 'Lifestyle Nutrition' && e !== 'Other Nutrition'
          )
        )
      );
    } else {
      setVerticalOptions(buildOptions(data));
    }
    setVerticalData(null);
  }, [marketData, setVerticalData, setVerticalOptions]);
  useEffect(() => {
    getVerticalOptions().catch((err) => {
      console.error('get vertical options error', err);
    });
  }, [getVerticalOptions]);

  const getVerticalOptions2 = useCallback(async () => {
    const { data } = await getFilter('vertical');
    setVerticalOptions2(
      buildOptions(
        data.filter(
          (e) => e !== 'Lifestyle Nutrition' && e !== 'Other Nutrition'
        )
      )
    );
    setVerticalData2(null);
  }, [setVerticalData2, setVerticalOptions2]);
  useEffect(() => {
    getVerticalOptions2().catch((err) => {
      console.error('get vertical 2 options error', err);
    });
  }, [getVerticalOptions2]);
  const getBrandOptions = useCallback(async () => {
    const { data } = await getProduct({
      vertical: verticalData2 ? [verticalData2] : [],
    });

    if (!data) return;
    const d2 = data.filter((e) => checkWeight(e.category, e.brand));
    const d3 = d2.map((e) => e.brand);
    const d3s = new Set(d3);

    setBrandOptions(buildOptions([...d3s].sort()));
    setBrandData(null);
  }, [verticalData2, setBrandData, setBrandOptions]);
  useEffect(() => {
    getBrandOptions().catch((err) => {
      console.error('get brand options error', err);
    });
  }, [getBrandOptions]);

  const onMarketChange = useCallback(
    (val) => {
      setMarketData(val);
      setVerticalData(null);
    },
    [setMarketData, setVerticalData]
  );
  const onVerticalChange = useCallback(
    (val) => {
      setVerticalData(val);
    },
    [setVerticalData]
  );

  const onVerticalChange2 = useCallback(
    (val) => {
      setVerticalData2(val);
      setBrandData(null);
    },
    [setVerticalData2, setBrandData]
  );
  const onBrandChange = useCallback(
    (val) => {
      setBrandData(val);
    },
    [setBrandData]
  );

  // 弹窗控制
  const [showFilter1, setshowFilter1] = useState(false);
  const [showFilter2, setshowFilter2] = useState(false);
  const showFilter = useCallback(
    (filter) => {
      if (filter === 'competitive') {
        setshowFilter1(true);
      } else if (filter === 'brand') {
        setshowFilter2(true);
      } else {
        console.warn('unkown filter', filter);
      }
    },
    [setshowFilter1, setshowFilter2]
  );
  const closeFilter = useCallback(
    (ev, filter) => {
      ev.stopPropagation();
      if (filter === 'competitive') {
        setshowFilter1(false);
      } else if (filter === 'brand') {
        setshowFilter2(false);
      } else {
        console.warn('unkown filter', filter);
      }
    },
    [setshowFilter1, setshowFilter2]
  );

  // confrim事件
  const onFinishCompetitive = useCallback(() => {
    if (!marketData || !verticalData) return;
    const s = new URLSearchParams();
    s.set('market', marketData);
    s.set('vertical', verticalData);
    navigate(`/package-ai-performance/competitive?${s.toString()}`);
  }, [marketData, verticalData]);
  const onFinishBrand = useCallback(() => {
    if (!brandData) return;
    const s = new URLSearchParams();
    s.set('brand', brandData);
    navigate(`/package-ai-performance/brand?${s.toString()}`);
  }, [brandData]);

  return (
    <div className={containerStyle.container}>
      <div className={style.box11}>
        <h1 className={style.title}>
          <img
            className={style.titleImg}
            src={titlePng}
            alt="Pack AI Performance"
          />
        </h1>
        <div className={style.navContainer}>
          <div className={style.nav} onClick={() => showFilter('competitive')}>
            <div className={style.iconBox}>
              <img className={style.icon} src={LinkSvg} />
            </div>
            <div className={style.navTitle}>Competitive Landscape</div>
            <div className={style.navDesc}>
              Understand how a brand performs compared to competitors in a
              specific market and category
            </div>
            <div className={style.navBg} />
            {showFilter1 && (
              <div className={style.filter}>
                <div
                  className={style.btnClose}
                  onClick={(ev) => closeFilter(ev, 'competitive')}
                />
                <h1 className={style.filterTitle}>Filter</h1>
                <div className={style.filterContainer}>
                  <div className={style.filterFormInner}>
                    <div className={style.greenInput}>
                      <Select
                        className={style.filterSelect}
                        placeholder="Market"
                        allowClear
                        onChange={onMarketChange}
                        value={marketData}
                        options={marketOptions}
                      />
                    </div>
                    <div className={style.greenInput}>
                      <Select
                        className={style.filterSelect}
                        placeholder="Vertical"
                        onChange={onVerticalChange}
                        value={verticalData}
                        options={verticalOptions}
                      />
                    </div>
                  </div>
                  <div className={style.btnWrap}>
                    <Button type="primary" onClick={onFinishCompetitive}>
                      Confirm
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={style.nav} onClick={() => showFilter('brand')}>
            <div className={style.iconBox}>
              <img className={style.icon} src={LightSvg} />
            </div>
            <div className={style.navTitle}>Vertical Drill Down</div>
            <div className={style.navDesc}>
              Understand how different brands perform across countries,
              subcategories and formats.
            </div>
            <div className={style.navBg} />
            {showFilter2 && (
              <div className={classNames(style.filter, style.brand)}>
                <div
                  className={style.btnClose}
                  onClick={(ev) => closeFilter(ev, 'brand')}
                ></div>
                <h1 className={style.filterTitle}>Filter</h1>
                <div className={style.filterContainer}>
                  <div className={style.filterFormInner}>
                    <div className={style.greenInput}>
                      <Select
                        className={style.filterSelect}
                        placeholder="Vertical"
                        onChange={onVerticalChange2}
                        value={verticalData2}
                        options={verticalOptions2}
                      />
                    </div>
                    <div className={style.greenInput}>
                      <Select
                        className={style.filterSelect}
                        placeholder="Brand"
                        allowClear
                        showSearch
                        onChange={onBrandChange}
                        value={brandData}
                        options={brandOptions}
                      />
                    </div>
                  </div>
                  <div className={style.btnWrap}>
                    <Button
                      className={style.btnConfirm}
                      type="primary"
                      onClick={onFinishBrand}
                    >
                      Confirm
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <VideoBg />
    </div>
  );
}

export default HomePage;
